import apiClient from "../http/apiClient";
import { LOCATION_ENDPOINTS } from "../http/endpoints";


export async function listDepartments(params = {}) {
  const response = await apiClient.get(LOCATION_ENDPOINTS.departments, { params });
  return response.data;
}


export async function listCities(params = {}) {
  const response = await apiClient.get(LOCATION_ENDPOINTS.cities, { params });
  return response.data;
}


export const locationService = {
  listDepartments,
  listCities,
};


export default locationService;
